import AnatomyV2WhatWeExplored from '~/pages/anatomyV2/whatWeExplored/libs/components/AnatomyV2WhatWeExplored'
import { TPageProps } from '~/shared/types/commonTypes'

const WhatWeExploredAnatomyV2 = (props: TPageProps) => (
  <AnatomyV2WhatWeExplored {...props} />
)

export default WhatWeExploredAnatomyV2
